<template src="./user-approval.html">
</template>
<script>
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import Loader from '@/components/misc/Loader'
  import PdfMake from 'pdfmake/build/pdfmake'
  import PdfFonts from 'pdfmake/build/vfs_fonts'
  import { getAccessToken } from '@/utils/cookie'

  export default {
    name: 'user-approval',
    components: {
      Loader
    },
    data () {
      return {
        priorityVariant: ['secondary', 'success', 'danger'],
        RegistrationStatus: {
          PENDING: 1,
          APPROVED: 2,
          CANCELLED: 3
        },
        registrationId: Number(this.$route.params.registrationId),
        registration: {},
        user: {},
        invoiceLimit: null,
        companyAddress: null,
        companyName: null,
        load: false
      }
    },
    computed: {
      isPublicEntity () {
        if (!this.registration || !this.registration.companyNumber) { return false }
        return this.registration.companyNumber.length === 5
      },
      isPrivateEntity () {
        if (!this.registration || !this.registration.companyNumber) { return false }
        return this.registration.companyNumber.length === 8
      },
      registrationCancelled () {
        return this.registration.status === this.RegistrationStatus.CANCELLED
      },
      registrationApproved () {
        return this.registration.status === this.RegistrationStatus.APPROVED
      },
      registrationPending () {
        return this.registration.status === this.RegistrationStatus.PENDING
      }
    },
    created: function () {
      // Unknown issue - bearer token removed for his query
      Vue.http.headers.common['Authorization'] = 'Bearer ' + getAccessToken()
      this.$http.get(Vue.$apiConfig.pendingRegistrationsGet + '/' + this.registrationId)
        .then(response => {
          this.logConsole(response)
          this.registration = response.data.payload
          this.companyAddress = this.registration.address
          this.companyName = this.registration.name
          if (!this.registrationApproved) {
            this.registration.adminLogin = this.formatInitialLogin()
          }
        }, error => {
          this.logConsole(error)
        })
    },
    methods: {
      validateAccountApproval () {
        this.approveAccount()
      },
      approveAccount () {
        this.load = true
        let tempRegistration = JSON.parse(JSON.stringify(this.registration))
        tempRegistration.treasuryBranch = this.registration.treasuryBranch.toString()
        Vue.delete(tempRegistration, 'invoiceLimit')
        this.user.registration = tempRegistration
        this.user.OrganizationId = this.registrationId
        this.user.login = this.registration.adminLogin
        this.user.name = this.registration.adminName
        this.user.email = this.registration.adminEmail

        this.$http.post(Vue.$apiConfig.approveRegisteredUserPost, this.user)
          .then(response => {
            this.logConsole(response)
            this.load = false
            // get body data
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userRegistration.registrationApproved'),
              errors: []
            })
            this.$refs.accountApprovalForm.reset()
            this.registration.status = this.RegistrationStatus.APPROVED
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      cancelAccount () {
        this.load = true
        let tempRegistration = JSON.parse(JSON.stringify(this.registration))
        Vue.delete(tempRegistration, 'invoiceLimit')
        tempRegistration.treasuryBranch = this.registration.treasuryBranch.toString()
        this.$http.post(Vue.$apiConfig.cancelRegisteredUserPost, tempRegistration)
          .then(response => {
            this.logConsole(response)
            this.load = false
            // get body data
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userRegistration.registrationCancelled'),
              errors: []
            })
            this.registration.status = this.RegistrationStatus.CANCELLED
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      printAdminForm () {
        PdfMake.vfs = PdfFonts.pdfMake.vfs
        let publicCompanyNumber = this.isPublicEntity ? this.registration.companyNumber : ''
        let privateCompanyNumber = this.isPrivateEntity ? this.registration.companyNumber : this.registration.budgetCompanyNumber

        let header = []
        if (!this.browserIE11()) {
          header.push({
            image: this.getBase64Image(this.$refs.imgToExport),
            width: 40,
            height: 65,
            alignment: 'left'
          })
        }
        header.push({ text: '\n\n' + 'Република Србија' + '\n' + 'МИНИСТАРСТВО ФИНАНСИЈА' + '\n' + 'Управа за трезор', fontSize: 10 })
        header.push({ text: '\n\n' + 'Образац ЦРФ-2' + '\n' + 'Централни регистар фактура', fontSize: 10, alignment: 'right' })

        var docDefinition = {
          content: [
            {
              columns: header
            },
            { text: '\n\n' + this.$t('userRegistration.adminFormTitle') + '\n\n\n', style: 'header' },
            { text: this.$t('register.legalEntityInfo') + '\n\n', style: 'subheader' },
            { text: this.$t('register.budgetIdNumber') + ' : ', fontSize: 12 },
            { text: publicCompanyNumber, style: 'value' },
            { text: this.$t('register.budgetIdNumberFootnote') + '\n\n', style: 'small' },
            { text: this.$t('register.companyName') + ' : ', fontSize: 12 },
            { text: this.registration.name + '\n\n', style: 'value' },
            {
              columns:
              [
                [
                  { text: this.$t('register.companyNumber') + ' : ', fontSize: 12 },
                  { text: privateCompanyNumber + '\n\n', style: 'value' }
                ],
                [
                  { text: this.$t('register.taxIdNumber') + ' : ', fontSize: 12 },
                  { text: this.registration.taxIdNumber + '\n\n', style: 'value' }
                ]
              ]
            },
            { text: this.$t('register.address') + ' : ', fontSize: 12 },
            { text: this.registration.address + '\n\n', style: 'value' },
            { text: this.$t('register.adminInfo') + '\n\n', style: 'subheader' },
            { text: this.$t('userAdministration.userLogin') + ' : ', fontSize: 12 },
            { text: this.registration.adminLogin + '\n\n', style: 'value' },
            { text: this.$t('register.name') + ' : ', fontSize: 12 },
            { text: this.registration.adminName + '\n\n', style: 'value' },
            { text: this.$t('register.email') + ' : ', fontSize: 12 },
            { text: this.registration.adminEmail + '\n\n', style: 'value' },
            {
              columns:
              [
                { text: '__________________________', fontSize: 12, alignment: 'left', margin: [ 15, 100, 0, 5 ] },
                { text: '_____________________________', fontSize: 12, alignment: 'right', margin: [ 0, 100, 15, 5 ] }
              ]
            },
            {
              columns:
              [
                { text: 'Предао у Управи за трезор', fontSize: 11, alignment: 'left', margin: [ 15, 0, 0, 0 ] },
                { text: 'Примио за правно лице/орган', fontSize: 11, alignment: 'right', margin: [ 0, 0, 15, 0 ] }
              ]
            }
          ],
          styles: {
            header: {
              fontSize: 16,
              bold: true,
              alignment: 'center'
            },
            value: {
              fontSize: 12,
              bold: true
            },
            subheader: {
              fontSize: 14,
              bold: true
            },
            quote: {
              italics: true
            },
            small: {
              fontSize: 8
            }
          }
        }
        PdfMake.createPdf(docDefinition).download('nalog.pdf')
      },
      printRegistrationForm () {
        PdfMake.vfs = PdfFonts.pdfMake.vfs
        let registrationToExport = Object.assign({}, this.registration)
        registrationToExport.budgetNumber = this.isPublicEntity ? this.registration.companyNumber : ''
        registrationToExport.companyNumber = this.isPrivateEntity ? this.registration.companyNumber : this.registration.budgetCompanyNumber

        this.exportRegistration(registrationToExport, this.$refs.imgToExport)
      },
      getBase64Image (img) {
        if (this.browserIE11()) { return }

        // Create an empty canvas element
        var canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height

        // Copy the image contents to the canvas
        var ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)

        // Get the data-URL formatted image
        // Firefox supports PNG and JPEG. You could check img.src to
        // guess the original format, but be aware the using "image/jpg"
        // will re-encode the image.
        return canvas.toDataURL('image/png')

        // return dataURL.replace(/^data:image\/(png|jpg);base64,/, '')
      },
      formatInitialLogin () {
        let transliterated = this.toBoldLatin(this.registration.adminName)
        return transliterated.trim().replace(/ +/g, '.').toLowerCase()
      },
      editInvoiceLimit () {
        this.registration.invoiceLimit = this.invoiceLimit
        this.editRegistration()
      },
      editAddress () {
        this.registration.address = this.companyAddress
        this.editRegistration()
      },
      editRegistration () {
        this.load = true
        this.$http.post(Vue.$apiConfig.editRegisteredUserInformation, this.registration)
          .then(response => {
            this.logConsole(response)
            this.load = false
            this.registration.invoiceLimit = response.data.payload.invoiceLimit
            // get body data
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userRegistration.registrationChangedText'),
              errors: []
            })
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      editName () {
        this.load = true
        this.registration.name = this.companyName
        this.$http.post(Vue.$apiConfig.editRegisteredUserName, this.registration)
          .then(response => {
            this.logConsole(response)
            this.load = false
            this.registration.name = response.data.payload.name
            // get body data
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userRegistration.registrationChangedText'),
              errors: []
            })
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>

  @import '~@/assets/scss/variables.scss';

  .user-info-label {
    font-weight: 600;
  }

  .user-revoked-card {
    background-color: transparentize($background-color-danger, .9) !important;
  }

  .user-approved-card {
    background-color: transparentize($background-color-success, .9) !important;
  }

  a label:hover {
    cursor:pointer;
  }

</style>



// WEBPACK FOOTER //
// UserApproval.vue?50e4624e